import React from 'react'
import { FontIcon, Button, Tooltipped, SimplePosition } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'

interface Props {
  id: string
  icon: string
  tooltip: string
  tooltipPosition?: SimplePosition
  whiteThemeBackgroundColor: string
  darkThemeBackgroundColor: string
  action: () => Promise<void>
  disabled?: boolean
}

const CustomButton: React.FC<Props> = ({
  id,
  icon,
  tooltip,
  tooltipPosition,
  whiteThemeBackgroundColor,
  darkThemeBackgroundColor,
  action,
  disabled,
}) => {
  const { promiseInProgress } = usePromiseTracker()
  const { theme } = useAuth()

  return (
    <Tooltipped id={id} tooltip={tooltip} position={tooltipPosition || 'above'}>
      <Button
        theme={disabled || promiseInProgress ? 'disabled' : 'clear'}
        disabled={disabled || promiseInProgress}
        buttonType='icon'
        style={
          disabled || promiseInProgress
            ? { margin: 2 }
            : theme === Theme.Dark
            ? { margin: 2, backgroundColor: darkThemeBackgroundColor, color: '#FFFFFF' }
            : { margin: 2, backgroundColor: whiteThemeBackgroundColor, color: '#212121' }
        }
        onClick={action}>
        <FontIcon>{icon}</FontIcon>
      </Button>
    </Tooltipped>
  )
}

export default CustomButton
